<script>  
    import Card from "../components/card.svelte";
    export let backURL = ""; 
</script>

<div class="row">
    <div class="col-12">
        <a class="btn btn-grey mb-3" href={backURL}><i
                class="fas fa-arrow-left" />
            Back</a>
    </div>
</div>
<slot name="title"/>
{#if $$slots.content}
    <slot name="content" />
{:else}
    <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
            <a class="active nav-link" data-toggle="tab" href="#tab1"><slot
                    name="tab1Header" /></a>
        </li>
        {#if $$slots.tab2Header}
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tab2"><slot
                        name="tab2Header" /></a>
            </li>
        {/if}
        {#if $$slots.tab3Header}
        <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#tab3"><slot
                    name="tab3Header" /></a>
        </li>
    {/if}
    {#if $$slots.tab4Header}
    <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#tab4"><slot
                name="tab4Header" /></a>
    </li>
{/if}
    </ul>

    <div class="tab-content">
        <div class="tab-pane active" id="tab1">
            <Card>
                <div slot="body">
                    <slot name="tab1Content" />
                </div>
            </Card>
        </div>
        {#if $$slots.tab2Content}
            <div class="tab-pane" id="tab2">               
                <slot name="tab2Content" />
            </div>
        {/if}
        {#if $$slots.tab3Content}
        <div class="tab-pane" id="tab3">               
            <slot name="tab3Content" />
        </div>
    {/if}
    {#if $$slots.tab4Content}
    <div class="tab-pane" id="tab4">               
        <slot name="tab4Content" />
    </div>
{/if}
    </div>
{/if}
